module.exports = __webpack_public_path__ + "static/img/total.56a2ccb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/total.png
// module id = Mi8k
// module chunks = 1